import React from 'react';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import TimeframePicker from './timeframe-picker';
import styles from './styles.module.scss';

import type { ITimeframeFilterProps } from './types';

const { Text } = Typography;

const TimeframeFilter: React.FC<ITimeframeFilterProps> = ({
  selectedRange,
  onRangeChange,
  clearSelection,
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      align="center"
      justify="space-between"
      gap="1.5rem"
      className={styles['filter-wrapper']}
    >
      <Text className={styles['filter-label']}>
        {t('homeDashboard.filterLabel', 'Filter')}
      </Text>
      <TimeframePicker
        selectedRange={selectedRange}
        onRangeChange={onRangeChange}
        clearSelection={clearSelection}
      />
    </Flex>
  );
};

export default TimeframeFilter;
